import NBType, { InferType } from '@netbase/nb-type'

/**
 * @typedef {object} ServiceResultEntryErrorSchema
 * @property {number} errorCode
 * @property {string} errorMessage
 * @property {string[]} errorParams
 */
const ServiceResultEntryErrorSchema = NBType.object().shape('ServiceResultEntryErrorSchema', {
  /* @prop */
  errorCode: NBType.number(),
  /* @prop */
  errorMessage: NBType.string(),
  /* @prop */
  errorParams: NBType.array().of(NBType.string())
  /* END */
})
export default ServiceResultEntryErrorSchema
export type ServiceResultEntryError = InferType<typeof ServiceResultEntryErrorSchema>
// RESERVE BELOW
